import {
	ISSUE_LINKS_FIELDTYPE,
	type Field,
	type IssueLink,
} from '../../../common/constants/fields';
import type {
	AdvancedOptions,
	ColumnMap,
	ColumnName,
	MappingState,
	ProjectData,
	UserMappingMap,
} from '../../../common/types';

const getFieldMappings = (columns: ColumnMap) => {
	const fieldMappings: Record<ColumnName, Field | IssueLink> = {};
	Object.values(columns || {}).forEach(({ columnName, field }) => {
		if (field && field.fieldType !== ISSUE_LINKS_FIELDTYPE) {
			const { fieldId, fieldName, fieldType } = field;
			fieldMappings[columnName] = { fieldId, fieldName, fieldType };
		}
	});
	return fieldMappings;
};

const getLinkMappings = (columns: ColumnMap) => {
	const linkMappings: Record<ColumnName, Field | IssueLink> = {};
	Object.values(columns || {}).forEach(({ columnName, field }) => {
		if (field) {
			const { fieldId, fieldName, fieldType, fieldDirection } = field;
			if (fieldType === ISSUE_LINKS_FIELDTYPE && fieldId && fieldDirection) {
				linkMappings[columnName] = {
					linkId: fieldId,
					linkName: fieldName,
					linkDirection: fieldDirection,
				};
			}
		}
	});
	return linkMappings;
};

const getUserMappings = (userMappings: UserMappingMap | null) => {
	const userMap: Record<string, string> = {};
	Object.values(userMappings || {}).forEach(({ cellValue, userValue }) => {
		if (userValue) {
			userMap[cellValue] = userValue;
		}
	});
	return userMap;
};

export const getConfiguration = (
	mappingState: MappingState | null,
	advancedOptions: AdvancedOptions,
	projectData: ProjectData,
) => {
	if (mappingState == null) {
		return {};
	}
	const {
		dateFormat,
		timeZoneOption: { value: timeZone },
		localeOption: { value: locale },
	} = advancedOptions;
	return {
		projectData,
		dateTimeProperties: { dateFormat, timeZone, locale },
		fieldMappings: getFieldMappings(mappingState.columns),
		linkMappings: getLinkMappings(mappingState.columns),
		userMappings: getUserMappings(mappingState.userMapping),
	};
};

export const getFileName = (projectName: string) => {
	const camelCase = projectName.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase());
	const date = new Date();
	return `${camelCase}_configuration_${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}.txt`;
};
